import { create } from "zustand";

export const useUploadFileStore = create((set) => ({
  uploadFiles: [],
  uploadFilesTask: [],
  uploadFilesComment: [],
  uploadFilesReply: [],
  abortController: null,

  setUploadFiles: (value) => set(() => ({ uploadFiles: value })),
  setUploadFilesTask: (value) => set(() => ({ uploadFilesTask: value })),
  setUploadFilesComment: (value) => set(() => ({ uploadFilesComment: value })),
  setUploadFilesReply: (value) => set(() => ({ uploadFilesReply: value })),
  setAbortController: (value) => set(() => ({ abortController: value })),
  cancelUpload: () => set((state) => {
    state.abortController?.abort(); // Cancel the request
    return {
      abortController: null // Reset state
    };
  }),
}));
